import type { Atom } from 'nanostores';

export class SubscribersList {
  #unsubscribers: ReturnType<Atom['subscribe']>[] = [];

  // Overloads to get the listener type from the atom if single atom
  subscribe<Value>(
    atom: Atom<Value>,
    listener: Parameters<Atom<Value>['subscribe']>[0],
  ): void;

  subscribe(
    atoms: Atom<unknown>[],
    listener: Parameters<Atom<unknown>['subscribe']>[0],
  ): void;

  subscribe<Value>(
    atoms: Atom<Value> | Atom<unknown>[],
    listener: Parameters<Atom<unknown>['subscribe']>[0],
  ) {
    if (!Array.isArray(atoms)) {
      atoms = [atoms];
    }

    atoms.forEach((atom, index) => {
      this.#unsubscribers.push(
        index === atoms.length - 1
          ? atom.subscribe(listener)
          : atom.listen(listener),
      );
    });
  }

  listen<Value>(
    atom: Atom<Value>,
    listener: Parameters<Atom<Value>['subscribe']>[0],
  ): void;
  listen(
    atoms: Atom<unknown>[],
    listener: Parameters<Atom<unknown>['subscribe']>[0],
  ): void;

  listen<Value>(
    atoms: Atom<Value> | Atom<unknown>[],
    listener: Parameters<Atom<unknown>['subscribe']>[0],
  ) {
    if (!Array.isArray(atoms)) {
      atoms = [atoms];
    }
    atoms.forEach((atom) => {
      this.#unsubscribers.push(atom.listen(listener));
    });
  }

  unsubscribeAll() {
    for (const unsubscribe of this.#unsubscribers) {
      unsubscribe();
    }
    this.#unsubscribers = [];
  }
}
